/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceMobileVibration = createReactComponent("outline", "device-mobile-vibration", "IconDeviceMobileVibration", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 4l2 0", "key": "svg-1" }], ["path", { "d": "M9 17l0 .01", "key": "svg-2" }], ["path", { "d": "M21 6l-2 3l2 3l-2 3l2 3", "key": "svg-3" }]]);

export { IconDeviceMobileVibration as default };
//# sourceMappingURL=IconDeviceMobileVibration.mjs.map
